// ── Listing keys ──────────────────────────────────────────────────────────────
//
// The identifier a table's column preferences are stored under. MUST match
// config/tableListings.js in the backend exactly — the server rejects a key it
// doesn't recognise with a 400, so a key that exists here and not there produces
// a "Unknown listing" toast on save.
//
// Import the constant instead of typing the string at the call site:
//
//   import { LISTINGS } from '../../../Components/TableCustomizer';
//   useCustomizableColumns({ listingKey: LISTINGS.ADMIN_TRIAL_LICENSES, columns })
//
// A typo'd constant is a build-time undefined; a typo'd string literal is a
// silently separate preference set that nothing ever reads back.

export const LISTINGS = {
  // ── Admin portal ───────────────────────────────────────────────────────────
  ADMIN_TRIAL_LICENSES:             'admin.trial_licenses',
  ADMIN_LICENSES:                   'admin.licenses',
  ADMIN_USERS:                      'admin.users',
  ADMIN_RESELLERS:                  'admin.resellers',
  ADMIN_ORDERS_GENERATED:           'admin.orders.generated',
  ADMIN_ORDERS_COMPLETED:           'admin.orders.completed',
  ADMIN_COUPONS:                    'admin.coupons',
  ADMIN_PRODUCTS:                   'admin.products',
  ADMIN_SERVICES:                   'admin.services',
  ADMIN_TAGS:                       'admin.tags',
  ADMIN_USER_PROFILES:              'admin.user_profiles',
  ADMIN_DOCUMENTS:                  'admin.documents',
  ADMIN_REQUESTED_QUOTES:           'admin.requested_quotes',
  ADMIN_VERIFICATION_CODES_LICENSE: 'admin.verification_codes.license',
  ADMIN_VERIFICATION_CODES_TRIAL:   'admin.verification_codes.trial',
  ADMIN_COMMAND_LOGS:               'admin.command_logs',

  // ── Customer portal ────────────────────────────────────────────────────────
  USER_LICENSES:                    'user.licenses',
  USER_ORDERS:                      'user.orders',
  USER_ATTACHED_MACHINES:           'user.attached_machines',
  USER_QUOTES:                      'user.quotes',
};

export default LISTINGS;
